import React from 'react'
import DeleteModal from './DeleteModal'

import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { deleteCategory, clearCategory } from 'modules/knowledgebase/actions'

import { getCategory } from 'modules/knowledgebase/selectors';

import './style.css'

const DeleteCategoryModalContent = ({ category, actions, onCloseModal, history, isOpen }) => {
  const multipleSectionsInCategory = category.sections && category.sections.length > 1
  const noSectionsInCategory = category.sections.length === 0
  const multipleUncategorizeDocuments = category.documents && category.documents.length > 1
  const noUncategorizedDocuments = category.documents.length === 0

  return (
    <DeleteModal
      onCloseModal={() => { 
        onCloseModal()
      }}
      isOpen={isOpen}
      onDelete={() => {
        actions.deleteCategory(category)
        history.push({pathname: '/category'})
        onCloseModal()
      }}
      onCancel={
        onCloseModal
      }
      title={ "Delete Category: " + category.name }
      body={(multipleSectionsInCategory || noSectionsInCategory ? 
        (`This category has ${category.sections.length} sections and `) : 
        (`This category has ${category.sections.length} section and `)) +
        (multipleUncategorizeDocuments || noUncategorizedDocuments ?
        (`${category.documents.length} articles`) : (`${category.documents.length} article.`)) + 
                " This category and its contents wil be removed from your knowledgebase." +
                " Any links that direct to it will no longer work."}
    />
)}

const mapStateToProps = state => ({
  category: getCategory(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteCategory,
    clearCategory
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeleteCategoryModalContent))